import styled, { css } from 'styled-components';

export const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
`;

export const Breadcrumb = styled.div`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.medium};
    text-decoration: underline;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    cursor: pointer;

    &:last-child {
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: unset;
      color: ${theme.v2.colors.neutral.lowMedium};
      cursor: not-allowed;
      pointer-events: none;
    }
  `}
`;
